import type { DialogProps } from './Dialog'
export type { DialogProps }

import Dialog from './Dialog'
export default Dialog

export { default as Backdrop } from './Backdrop'
